import type { Message } from '@/types/chat';
import { useChatColors } from '@/contexts/ChatColorsContext';
import ChatActionButtons from './ChatActionButtons';

interface MessageBubbleProps {
  message: Message;
  onFlowButtonClick: (value: string, msgId: string) => void;
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export default function MessageBubble({ message, onFlowButtonClick }: MessageBubbleProps) {
  const { primary } = useChatColors();
  const isBot = message.type === 'bot';

  if (isBot) {
    return (
      <div className="flex flex-col items-start mb-4">
        <div className="flex items-end gap-2">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm"
            style={{ background: `linear-gradient(135deg, ${primary}cc, ${primary})` }}
          >
            <span className="text-white font-bold text-xs">B</span>
          </div>
          <div className="max-w-[220px] sm:max-w-xs">
            <div className="bg-white rounded-2xl rounded-bl-sm px-4 py-3 shadow-sm border border-gray-100">
              <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">{message.text}</p>
            </div>
            <p className="text-xs text-gray-400 mt-1 ml-1">{formatTime(message.timestamp)}</p>
          </div>
        </div>
        {message.actionButtons && message.actionButtons.length > 0 && (
          <ChatActionButtons
            buttons={message.actionButtons}
            used={message.buttonsUsed}
            onFlowClick={(val) => onFlowButtonClick(val, message.id)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-end mb-4">
      <div className="max-w-[220px] sm:max-w-xs">
        <div
          className="rounded-2xl rounded-br-sm px-4 py-3 shadow-sm"
          style={{ background: `linear-gradient(135deg, ${primary}dd, ${primary})` }}
        >
          <p className="text-white text-sm leading-relaxed whitespace-pre-line">{message.text}</p>
        </div>
        <p className="text-xs mt-1 text-right mr-1" style={{ color: `${primary}99` }}>
          {formatTime(message.timestamp)}
        </p>
      </div>
    </div>
  );
}
